import { createContext } from 'react'

interface TransitionContext {
  open: boolean
}

const TransitionContext = createContext<TransitionContext>({ open: false })

export default TransitionContext
